// extracted by mini-css-extract-plugin
export default {"root":"SingleSignOnModal_root__17qbw"};